module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col m3 s12 left-align"
  }, [_c('br'), _c('br'), _c('h1', [_vm._v("Papers")]), (_vm.$route.query.algorithmname) ? _c('p', [_vm._v("Algorithm: " + _vm._s(this.$route.query.algorithmname))]) : _vm._e(), (_vm.$route.query.title) ? _c('p', [_vm._v("Filter Title: " + _vm._s(this.$route.query.title))]) : _vm._e(), (_vm.$route.query.sort) ? _c('p', [_vm._v("Sort by: " + _vm._s(_vm.$route.query.sort))]) : _vm._e(), (_vm.$route.query.author) ? _c('p', [_vm._v("Author: " + _vm._s(_vm.$route.query.author))]) : _vm._e(), (_vm.query.algorithmname) ? _c('div', {
    staticClass: "strictSelector"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.strict),
      expression: "query.strict"
    }],
    attrs: {
      "type": "checkbox",
      "id": "strict"
    },
    domProps: {
      "checked": Array.isArray(_vm.query.strict) ? _vm._i(_vm.query.strict, null) > -1 : (_vm.query.strict)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.query.strict,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.query.strict = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.query.strict = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.query.strict = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "strict"
    }
  }, [_vm._v("Strict")])]) : _vm._e(), _c('div', {
    staticClass: "sortBy"
  }, [_vm._l(([
    ['year', 'Year'],
    ['pubtitle', 'PubTitle']
  ]), function(a) {
    return _c('p', [_c('input', {
      staticClass: "with-gap",
      attrs: {
        "name": "sortBy",
        "type": "radio",
        "id": a[0]
      },
      domProps: {
        "checked": _vm.query.sort == a[0]
      }
    }), _c('label', {
      attrs: {
        "for": a[0]
      },
      on: {
        "click": function($event) {
          _vm.query.sort = a[0]
        }
      }
    }, [_vm._v(_vm._s(a[1]))])])
  }), _c('div', {
    staticClass: "switch"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.inverse),
      expression: "query.inverse"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.query.inverse) ? _vm._i(_vm.query.inverse, null) > -1 : (_vm.query.inverse)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.query.inverse,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.query.inverse = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.query.inverse = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.query.inverse = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "lever"
  }), _vm._v("Inverse")])])], 2), _c('br'), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.query.skip = 0;
        _vm.pushRoute()
      }
    }
  }, [_vm._v("Update Search")])]), _c('div', {
    staticClass: "col m9 s12"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('p', [_c('small', [_vm._v(_vm._s(_vm.total) + " Articles found. Page " + _vm._s(_vm.page) + "/" + _vm._s(_vm.pages))])]), _vm._l((_vm.data), function(p, index) {
    return _c('div', {
      staticClass: "paper left-align"
    }, [_c('div', {
      staticClass: "col s12"
    }, [_c('p', [_c('b', [_c('a', {
      attrs: {
        "href": p.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(p.title))])]), _c('br'), _vm._l((p.authors), function(a) {
      return _c('span', [_c('a', {
        on: {
          "click": function($event) {
            _vm.findAuthor(a)
          }
        }
      }, [_vm._v(_vm._s(a) + ";")])])
    }), _c('br'), _c('small', [_vm._v(_vm._s(p.pubtitle))]), _c('br'), _c('small', [_vm._v("Year: " + _vm._s(p.year))]), (!_vm.query.algorithmname) ? _c('small', {
      on: {
        "click": function($event) {
          _vm.query.algorithmname = p.algorithmname;
          _vm.query.skip = 0;
          _vm.pushRoute()
        }
      }
    }, [_vm._v(", Reference to: " + _vm._s(p.algorithmname))]) : _vm._e()], 2)]), (index < _vm.data.length - 1) ? _c('hr') : _vm._e()])
  }), _c('div', {
    staticClass: "col s12"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    class: {
      disabled: _vm.page == 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.gotoPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")])])]), _vm._l((_vm.pagesList), function(i) {
    return _c('li', {
      class: {
        active: (i == parseInt(_vm.page))
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.gotoPage(i)
        }
      }
    }, [_vm._v(_vm._s(i))])])
  }), _c('li', {
    class: {
      disabled: _vm.page == _vm.pages
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.gotoPage(_vm.pages)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])])])], 2)])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-367b5a15"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Papers.vue
// module id = 82
// module chunks = 1